import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './products.html'

/**
 * Products report route
 *
 * @namespace routes.ReportProducts
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.products.list',
  label: 'REPORT.PRODUCTS.TITLE',
  url: '/products',
  component: 'tmrReportProducts',
  weight: 2,
  resourceType: 'Product',
  resourceList: {
    searchParameters: [
      'code',
      'style.value',
      'style.valueDescription',
      'material.value',
      'material.valueDescription',
      'color.value',
      'color.valueDescription',
      'size.value',
      'size.valueDescription',
    ],
  },
  resolve: {
    productImageEnabled: /*@ngInject*/ appConfiguration =>
      appConfiguration['product.image.enabled'],
  },
}

/**
 * Component for {@link routes.tmrReportProducts Products report route}
 *
 * @type {ngComponent}
 */
export const tmrReportProducts = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings({
    productImageEnabled: '<',
  }),
}
